module.exports = __webpack_public_path__ + "static/media/home-graphic-1.ca5fe12d.png";